import { periods, recurrences } from '../common/constants/date';
import { getRequestObjectByMethodType, handleApiError } from '../common/helpers/api';
import { formatShortDate, getDateRangeFromRecurrence } from '../common/helpers/date';
import { apiRequestTypes } from '../constants/service';
import { BROKER_METRICS_API, getEndpoint } from '../providers/endpoint.provider';
import { useAuthStore } from '../store/auth/store';

const defaultRequestTimeout = 10000;

export const sendBrokerMetricsApiRequest = async ({
    endpoint,
    inputParameters,
    requestTimeout,
    propsToken,
    isJsonResponse = true,
    propsActiveClientId,
    requestType = apiRequestTypes.post,
    queryString,
    isPlainResponse,
    customErrorMessage = null,
    suppressToast = false,
}) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
        controller.abort();
    }, requestTimeout ?? defaultRequestTimeout);
    const authStore = useAuthStore.getState();
    const token = propsToken || authStore.token;
    const activeClientId = propsActiveClientId || authStore.activeClientId;

    if (!token) return { error: 'No token has been provided. Unable to process request.' };
    const url = `${getEndpoint(BROKER_METRICS_API)}/v1/${endpoint}`;
    try {
        const response = await fetch(
            getRequestObjectByMethodType({
                url,
                token,
                activeClientId,
                data: { inputParameters },
                queryString
            })[requestType],
            { signal: controller.signal }
        );

        if (response.status === 403 || response.status == 401) {
            useAuthStore.getState().handleExpiredToken();
            return { error: response.status };
        }

        handleApiError({ response, endpoint, customErrorMessage, suppressToast });

        if (!response.ok) return response.status;
        if (isPlainResponse) return response;

        return isJsonResponse ? response.json() : response.body;
    } catch (error) {
        return { error };
    } finally {
        clearTimeout(timeoutId);
    }
};

export const getAgentProductivityLtm = async ({ mlsId, officeIds, brokerIds }) => {
    const { startDate, endDate } = getDateRangeFromRecurrence(recurrences.lastTwelveMonths);
    return await sendBrokerMetricsApiRequest({
        endpoint: 'office/agent-performance',
        requestType: apiRequestTypes.get,
        queryString: `mlsId=${mlsId}${officeIds ? '&officeIds=' + officeIds : ''}${
            brokerIds ? '&brokerIds=' + brokerIds : ''
        }&startDate=${formatShortDate(startDate)}&endDate=${formatShortDate(endDate)}&Periods=${periods.lastTwelveMonths}`
    });
};
